import React from 'react';
import {Link} from 'react-router-dom';

import SocialMediaField from '../../UI/SocialMediaField/SocialMediaField';
import Backdrop from '../../UI/Backdrop/Backdrop';
import Aux from '../../../containers/hoc/Auxiliary';
import SideDrawerCloseButton from '../../UI/Buttons/SideDrawerCloseButton/SideDrawerCloseButton';
import backIcon from '../../../icons/backMediumLarge.svg';

import classes from './SideDrawer.css';

const sideDrawer = props => {

    let attachedClasses = [classes.SideDrawer, classes.Close];

    if(props.open) {
        attachedClasses = [classes.SideDrawer, classes.Open];
    }

    const helpGroup = ( 
        <div className={classes.HelpGroup}>
                <Link to="/help/about" 
                    onClick={props.closed}
                    className={[classes.NavLinks, classes.HelpItem].join(' ')}>
                    <p>About</p>
                    </Link>
                    <p className={classes.SplitListBar}>|</p>
                <Link to="/help/contact" 
                    onClick={props.closed}
                    className={[classes.NavLinks, classes.HelpItem].join(' ')}>
                    <p>Contact</p>
                </Link>
            </div>
    )

    let authLink = (
        <Aux >
            <Link to="/admin" 
                onClick={props.closed}
                className={classes.NavLinks}>
                <p>Admin Console</p>
        
            </Link>
            
            
        </Aux>)


    if (props.isAuth) {
        authLink = (
            <Aux>
                <Link to="/admin" 
                onClick={props.closed}
                className={classes.NavLinks}>
                <p>Admin Console</p>
        
                </Link>
                
                <Link to="/logout" 
                    onClick={props.closed}
                    className={classes.NavLinks}>
                <p>Logout</p>
            
                </Link>
                

            </Aux>
            )
    }



    return (
        <Aux>
            <Backdrop
                show={props.open}
                clicked={props.closed} />
            
            <div className={attachedClasses.join(' ')}>
                
                <div className={classes.DrawerWrapper}>
                    
                        <div className={classes.TopNavSection}>
                            <h1 className={classes.NavTitle}>~ Navigation ~</h1>
                        </div>
                        <hr />
                        <div className={classes.SpacingTop}></div>
                    <nav className={classes.NavItems}>
                        <Link to="/trd" 
                            onClick={props.closed} 
                            className={classes.NavLinks}>
                                {/* Timed Registration Drop */}
                            <p className={classes.MenuItem}>Timed Registration Drops</p>
                        </Link>
                        {authLink}
                    </nav>
                    <div className={classes.SideDrawerCloseButton}>
                        <SideDrawerCloseButton icon={backIcon} clicked={props.closed}/>
                    </div>
                    
                    <div className={classes.BottomFields}>
                        {helpGroup}
                        <hr />
                        <div className={classes.SpacingBottom}></div>
                        <SocialMediaField />
                    </div>
                    
                </div>
            </div>
        </Aux>
    )

}

export default sideDrawer;


// WEBPACK FOOTER //
// ./src/components/Navigation/SideDrawer/SideDrawer.js